import { ApolloClient, InMemoryCache, from } from "@apollo/client";
import { useRef } from "react";

import { getHttpLink } from "./apollo-links";

const cache = new InMemoryCache();
export const useGetApolloClient = () => {
  // Singleton apollo client
  const clientRef = useRef(
    new ApolloClient({
      link: from([getHttpLink()]),
      cache: cache,
    })
  );

  return clientRef.current;
};
